// @flow
import $ from "../vendor/jquery";

// Global grobot objects
import global, {
    alert,
    make_a_results_page
} from "./Global";
import AppConfig from "../config";
import {asString, htmlEncode, jsonAjax, limit_timestamp} from "../util";
import {convert_data_row} from "./Drow";

import Settings from "./Settings";

import ArchiveExport from "./ArchiveExport";
import t from "../trans";
import {MeasurementType} from "../model";
import type {ConvertedMeasurementType} from "../model";
import Popup from "../Popup";
import Legacy from "../Legacy";
import rootStore from "../stores";

/**
 * Arhiivi moodul
 */
class Archive {
    /**
     * @private
     * @type {?Archive}
     */
    static archiveInstance = null;

    /**
     *
     * @returns {Archive}
     */
    static getInstance() {
        if (Archive.archiveInstance == null) Archive.archiveInstance = new Archive();
        return Archive.archiveInstance;
    }

    constructor() {
        this.conf_archive_url = AppConfig.BASE_URL + "/measurements";
    }

    archive_search() {
        this.load_archive();
    }

    load_archive() {
        let settings = Settings.getInstance();

        // toote_variant={toote_variant}&kirjeldus={kirjeldus}&aeg={aeg}
        let codeVariant = $("#product_code_fid").val();
        let desc = $("#desc_fid").val();
        let time = $("#date_fid").val();
        let etime = $("#edate_fid").val();
        let skeleton = $("#skeleton_fid").val();
        let furnaceRing = $("#furnace_ring_fid").val();
        let glassId = $("#glass_id_fid").val();
        let useCurrentNominals = $("#use_current_nominals").is(':checked');
        if (!codeVariant && !desc && !time && !etime && !skeleton && !furnaceRing && !glassId) {
            alert(t("Please fill some fields!"));
            return false;
        }
        let tmp = "arv=" + settings.getMaxRecords();
        if (codeVariant)
            tmp += "&toote_variant=" + encodeURIComponent(codeVariant);
        if (desc)
            tmp += "&kirjeldus=" + encodeURIComponent(desc);
        if (skeleton)
            tmp += "&vaguni_raam=" + encodeURIComponent(skeleton);
        if (furnaceRing)
            tmp += "&ahju_ring=" + encodeURIComponent(furnaceRing);
        if (glassId)
            tmp += "&klaasi_id=" + encodeURIComponent(glassId);
        if (time) {
            time = time.replace(" ", "T");
            tmp += "&algus=" + encodeURIComponent(time);
        }
        if (etime) {
            etime = etime.replace(" ", "T");
            tmp += "&lopp=" + encodeURIComponent(etime);
        }
        if (useCurrentNominals) {
            tmp += "&use_current_nominals=y";
        }

        if (global.a_passwd)
            tmp += "&passwd=" + encodeURIComponent(global.a_passwd);
        let url = this.conf_archive_url + "?" + tmp;
        Legacy.debug("loading " + url);
        jsonAjax({
            type: "GET",
            url: url,
            success: function (data: MeasurementsResultType) {
                this.measurementscall(data);
            }.bind(this),
            statusCode: {
                403: function () {
                    console.log("load_archive(): STATUS 403: invalidating session, url: " + url);
                    rootStore.sessionStore.invalidate();
                    global.a_passwd = null;
                }
            },
            error: function (xhr, status, error) {
                Popup.show_err(t("Error") + ": " + error);
            }
        });
    }

    measurementscall(data: MeasurementsResultType) {
        let settings = Settings.getInstance();

        if (data && data.measurementsResult) {
            // Legacy.debug(data["measurementsResult"][0]["joone_pikkus"]);
            global.a_results = data.measurementsResult;
            global.a_measurement = null;
            for (let y = 0; y < global.a_results.length; y++) {
                global.a_converted_results[y] = convert_data_row(global.a_results[y]);
            }
            make_a_results_page();
            if (global.a_results.length === settings.getMaxRecords())
                Popup.show_success(t("Maximum number of records exceeded"));
            global.force_correct = false;
        } else {
            global.a_results = [];
            global.a_converted_results = [];
            Popup.show_err(t("Data not found."));
        }
    }

    /**
     *
     * @param {number} i
     * @returns {string}
     */
    getPName(i) {
        let settings = Settings.getInstance();

        let m = settings.getMeasurementLineCount()*3;
        if (i >= m) {
            return "P" + ((i-m+1)*50).toString();
        } else {
            return "P" + (i+1).toString();
        }
    }

    getHudPName(i) {
        return "H" + (i+1).toString();
    }

    /**
     *
     * @returns {string}
     */
    make_a_results_table() {
        let settings = Settings.getInstance();

        let lst: Array<MeasurementType> = global.a_results;

        let activeRow = -1;
        if (global.a_measurement && global.a_measurement["rowNo"] !== undefined)
            activeRow = global.a_measurement["rowNo"];
        if (!lst || lst.length === 0) {
            return t("Data not found.");
        }

        let tl = [];
        tl.push("\n<table id='a_resultstable' class='table tablesorter table-condensed table-hover'>\n");

        tl.push("<thead>\n");
        tl.push("<tr class='gridtr gridtrhead'>\n");
        tl.push("<th style='width: 20px;'>#</th>");
        if (!settings.isSimpleUi()) tl.push("<th style='width: 30px;' title='"+ t("Wagon no") +"'>" + t("W") + "</th>");
        tl.push("<th style='width: 30px;' title='"+ t("Skeleton no") +"'>" + t("S") + "</th>");
        if (!settings.isSimpleUi()) tl.push("<th style='width: 30px;' title='"+ t("Error code") +"'>" + t("E") + "</th>");
        tl.push("<th style='width: 150px;'>" + t("Time") + "</th>");
        tl.push("<th style='width: 50px;' title='"+ t("Product code") +"'>" + t("C") + "</th>");
        tl.push("<th>" + t("Description") + "</th>");

        let showCenter = settings.showOnlyCenterPoints();
        let i = 0;
        // P1 - P9/15
        let first = true;
        for (; i < settings.getMeasurementLineCount() * 3; i++) {
            if (showCenter && (i % 3 !== 1)) continue;
            let cclass = (first ? "gridthsep" : "");
            tl.push("<th style='width: 40px;' class='"+cclass+"'>" + this.getPName(i) + "</th>");
            first = false;
        }
        // P300 - P50
        first = true;
        for (let j = settings.getCenterAddPoints()-1; j >= 0; j--) {
            let cclass = (first ? "gridthsep" : "");
            tl.push("<th style='width: 40px;' class='"+cclass+"'>" + this.getPName(i+j) + "</th>");
            first = false;
        }

        // ANGLE
        tl.push(`<th style="width: 40px;">${t("angle")}</th>`);

        // HUD points
        first = true;
        for (let j = 0; j < settings.getHudPoints(); j++) {
            let cclass = (first ? "gridthsep" : "");
            tl.push("<th style='width: 40px;' class='"+cclass+"'>" + this.getHudPName(j) + "</th>");
            first = false;
        }

        tl.push("</tr>\n");
        tl.push("</thead>\n");
        tl.push("<tbody>\n");

        for (let r = 0; r < lst.length; r++) {
            tl.push("<tr class='gridtr" + (activeRow === r ? " danger" : "") + "' id='gridtr" + r
                + "' onclick='graph.show_a_measurement(" + r + ")'>\n");
            tl.push("<td class='gridtd'>" + (r + 1) + "</td>");
            if (!settings.isSimpleUi()) {
                tl.push("<td class='gridtd'>");
                try {
                    tl.push(asString(lst[r]["vaguni_number"]));
                } catch (err) {
                }
                tl.push("</td>");
            }
            tl.push("<td class='gridtd'>");
            try {
                tl.push(asString(lst[r]["vaguni_raam"]));
            } catch (err) {
            }
            tl.push("</td>");

            if (!settings.isSimpleUi()) {
                tl.push("<td class='gridtd'>");
                try {
                    let value = asString(lst[r]["veakood"]);
                    if (value == "0") value = "";
                    tl.push(value);
                } catch (err) {
                }
                tl.push("</td>");
            }

            tl.push("<td class='gridtd'>");
            try {
                tl.push(" " + limit_timestamp(lst[r]["lopp_aeg"]));
            } catch (err) {
            }
            tl.push("</td>");
            tl.push("<td class='gridtd'>");
            try {
                tl.push(asString(lst[r]["toote_variant"]) + " ");
            } catch (err) {
            }
            tl.push("</td>");
            tl.push("<td class='gridtd'>");
            try {
                tl.push(htmlEncode(asString(lst[r]["kirjeldus1"]) + " " + asString(lst[r]["kirjeldus2"])));
            } catch (err) {
            }
            tl.push("</td>");

            let drow: ConvertedMeasurementType = global.a_converted_results[r];
            let p = 0;
            // P1 - P9/15
            first = true;
            for (; p < settings.getMeasurementLineCount() * 3; p++) {
                if (showCenter && (p % 3 != 1)) continue;
                let cclass = (first ? "gridsep" : "");
                tl.push(this.make_a_result_nominal_col(drow, p, cclass));
                first = false;
            }
            // P300 - P50
            first = true;
            for (let k = settings.getCenterAddPoints()-1; k >= 0; k--) {
                let cclass = (first ? "gridsep" : "");
                tl.push(this.make_a_result_nominal_col(drow, p+k, cclass));
                first = false;
            }

            // ANGLE:
            let cvalue = "";
            let cclasses = "";
            if (drow && drow.angles && drow.angles.length > 0 && drow.angles[0].length > 0 && drow.angles[0][0] != null && drow.analyzed_angles && drow.analyzed_angles.length > 0) {
                // [diff, status, y]
                cvalue = ((Math.round(drow.analyzed_angles[0][2])) / 10).toString();

                let cstatus = drow.analyzed_angles[0][1];
                cclasses += " row_status_" + cstatus;
            }
            tl.push(`<td class="gridtd ${cclasses}">${cvalue}</td>`);

            // HUD points
            p += settings.getCenterAddPoints();
            first = true;
            for (let k = 0; k < settings.getHudPoints(); k++) {
                let cclass = (first ? "gridsep" : "");
                tl.push(this.make_a_result_nominal_col(drow, p+k, cclass));
                first = false;
            }

            tl.push("</tr>\n");
        }
        tl.push("</tbody>\n");
        tl.push("</table>\n");

        return tl.join("");
    }

    make_a_result_nominal_col(drow: ?ConvertedMeasurementType, p: number, cclasses: string): string {
        let cvalue = "";
        let cstatus = null;
        if (drow && drow.required && drow.required[p] != null && drow.required[p].length > 0 && drow.required[p][0] != null && drow.analyzed && drow.analyzed.length > p) {
            cvalue = drow.analyzed[p][2];
            cvalue = (Math.round(cvalue)) / 10;
            // AA: -100 is a result of missing data; TODO: raw data
            // should be set null earlier
            if (cvalue == -100)
                cvalue = "";

            cstatus = drow.analyzed[p][1];
            if (((p % 3 == 1) && (cvalue || cvalue === 0)) || drow.lineinfo[p][2]) {
                cclasses += " gridtd_imp ";
            }
            cclasses += " row_status_" + cstatus;
        }

        return '<td class="gridtd ' + cclasses + '">' + cvalue + '</td>';
    }

    make_a_export() {
        let exportActive: boolean = false;
        if (global.a_measurement && global.a_measurement["rowNo"] !== undefined) {
            if ($("#a_measurement_li").hasClass("active")) exportActive = true;
            else if ($("#a_tolerances_li").hasClass("active")) exportActive = true;
        }

        let archiveExport = new ArchiveExport();
        archiveExport.export(exportActive);
    }
}

export default Archive;
